var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.text)?_c('div',{staticClass:"draft-org-flag",staticStyle:{"color":"red","text-align":"center","transform-origin":"top left","-webkit-transform-origin":"left top"},style:({'font-weight':_vm.item.bold?'bold':'',
     'font-family':_vm.item.font,
     'letter-spacing':_vm.item.letterSpace?_vm.item.letterSpace+'pt':'0pt',
     'width':_vm.item.scale?100/_vm.item.scale+'%':'100%',
     'font-size':_vm.item.fontSize,
     'transform':'scalex('+_vm.item.scale+')',
     '-webkit-transform':'scalex('+_vm.item.scale+')'})},_vm._l((_vm.item.text.split('\n')),function(text,index){return _c('div',{key:index,style:({'text-align-last':_vm.item.align})},[_vm._v("\n        "+_vm._s(text)+"\n    ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }